const ColorUtility = require('utility-ts-type').ColorUtility;

angular
  .module('ui-ng-university-branding')
  .directive(
    'universityBranding',
    function universityBrandingDefinition(DelegateResponder, universityBrandingDelegateConfiguration) {
      return {
        scope: {
          primaryColor: '=?',
          secondaryColor: '=?',
          textColor: '=?',
          additionalStyles: '=?'
        },
        restrict: 'E',
        link: DelegateResponder(universityBrandingDelegateConfiguration, (scope, element, attrs) => {}),
        controller: function universityBrandingController($scope, $element, universityBrandingSettings) {
          const transformTextToColor = (hexColor) => {
            if (hexColor === defaultBranding.cssDefault || _.isEmpty(hexColor)) {
              return defaultBranding.defaultColor;
            }
            return hexColor;
          };

          // not used anymore
          //
          // const handleDefaultTextColor = (hexColor) => {
          //   if (hexColor === defaultBranding.cssDefault || _.isEmpty(hexColor)) {
          //     return defaultBranding.defaultWhite;
          //   }
          //   return hexColor;
          // };

          const hexToShadedRGB = (hexColor) => {
            return ColorUtility.getAllShadesOfHex(transformTextToColor(hexColor));
          };

          const hexToTintedRGB = (hexColor) => {
            return ColorUtility.getAllTintsOfHex(transformTextToColor(hexColor));
          };

          /**
           * we add colors to a global and intend to carry these in to other functions in mobile
           */
          const updateBrandObject = (brandConfig) => {
            const { primaryColor, secondaryColor, textColor, tint, shade } = brandConfig;
            // this is a terrible way to share data (dumping values on a global)
            //
            ColorUtility.universityStyles = { primaryColor, secondaryColor, textColor, tint, shade };
          };

          let defaultBranding = universityBrandingSettings.getBrandingDefaultColor();

          const DEFAULTS = {
            primaryColor: defaultBranding.cssDefault,
            secondaryColor: defaultBranding.cssDefault,
            textColor: defaultBranding.cssDefault,
            additionalStyles: '',
            tint: hexToTintedRGB(defaultBranding.cssDefault),
            shade: hexToShadedRGB(defaultBranding.cssDefault)
          };

          let brandConfig = universityBrandingSettings.updateBrandConfiguration(DEFAULTS, {});

          const parseStyles = (template) => {
            const hexColor =
              $scope.primaryColor === defaultBranding.cssDefault ? defaultBranding.defaultColor : $scope.primaryColor;
            let compileTpl = _.template(template);

            return compileTpl({
              primary: $scope.primaryColor,
              secondary: $scope.secondaryColor,
              text: $scope.textColor,
              tint: hexToTintedRGB(hexColor),
              shade: hexToShadedRGB(hexColor)
            });
          };

          let styleTemplate = universityBrandingSettings.getBrandingTemplate();

          const updateStyles = () => {
            _.assign($scope, brandConfig);

            $scope.compiledAdditionalStyles = parseStyles($scope.additionalStyles);
            $scope.universityStyles = parseStyles(styleTemplate) + $scope.compiledAdditionalStyles;
            $element.html(`<style type='text/css'> ${$scope.universityStyles}</style>`);
            updateBrandObject(brandConfig);
          };

          updateStyles();

          $scope.updateColors = (config) => {
            brandConfig = universityBrandingSettings.updateBrandConfiguration(DEFAULTS, config);
            updateBrandObject(brandConfig);
            updateStyles();
          };
        }
      };
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-university-branding/src/lib/university_branding_directive.es.js